import { Resource } from "react-admin";
import ListIcon from "@material-ui/icons/LocalOffer";
import React from "react";
import { POLICY_TICKETS } from "../../common/rolesManagement";
import PermissionDenied from "../../components/PermissionDenied";
import List from "./List";
import Edit from "./Edit";
import Create from "./Create";

export default permissions => (
    <Resource
        name="tickets"
        icon={ListIcon}
        list={
            permissions &&
            (permissions.includes(POLICY_TICKETS.READ) ||
                permissions.includes(POLICY_TICKETS.READ_ALL_USERS) ||
                permissions.includes(POLICY_TICKETS.READ_ALL_COMPANIES))
                ? List
                : PermissionDenied
        }
        edit={
            permissions && permissions.includes(POLICY_TICKETS.UPDATE)
                ? Edit
                : PermissionDenied
        }
        create={
            permissions &&
            (permissions.includes(POLICY_TICKETS.CREATE) ||
                permissions.includes(POLICY_TICKETS.SAFE_CREATE))
                ? Create
                : PermissionDenied
        }
    />
);



// WEBPACK FOOTER //
// ./src/resources/Tickets/index.js